const setUsers = (state, action) => {
  const { users } = action.payload;

  return {
    ...state,
    users,
  };
};

const updateUsersToSearch = (state, action) => ({
  ...state,
  filters: {
    ...state.filters,
    usersToSearch: action.payload,
  },
});

const updateUsersPagination = (state, action) => ({
  ...state,
  pagination: {
    ...state.pagination,
    ...action.payload,
  },
});

const updateUsersSortBy = (state, action) => ({
  ...state,
  sortBy: {
    ...state.sortBy,
    ...action.payload,
  },
});

const updateActiveUser = (state, action) => ({
  ...state,
  activeUser: {
    ...action.payload.user,
  },
});

const setIsLoadingUsers = (state, action) => ({
  ...state,
  isLoadingUsers: action.payload.isLoadingUsers,
});

export const globalDataReducers = {
  SET_USERS: setUsers,
  SET_IS_LOADING_USERS: setIsLoadingUsers,
  UPDATE_USERS_TO_SEARCH: updateUsersToSearch,
  UPDATE_USERS_PAGINATION: updateUsersPagination,
  UPDATE_USERS_SORT_BY: updateUsersSortBy,
  UPDATE_ACTIVE_USER: updateActiveUser,
};
